import React, { useEffect, useState } from "react";
import Spinner from "@atlaskit/spinner";
import { API } from "../../utility/Api";
import moment from "moment";
import RestorePreview from "../../components/Restore/RestorePreview/RestorePreview";
import RestoreFilter from "../../components/Restore/RestoreFiter/RestoreFilter";
import FlagError from "../../components/Shared/Error/FlagError";
import ModalPrompt from "../../components/Shared/Modal/ModalPrompt";
import Button from "@atlaskit/button";

import {
  checkFilterData,
  setUniqueIssues,
  issuesToRemove,
  errorHandler,
  camelToTitle,
} from "../../helpers/helpers";
import { useNavigate } from "react-router-dom";
import styles from "./Restore.module.css";
import RestorePreviewConfig from "../../components/Restore/RestorePreviewConfig/RestorePreviewConfig";
import { UseToast } from "../../components/context/ToastContext";

import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
import filter from "@atlaskit/icon/glyph/filter";

const Restore = (props) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showDownloadConfirm, setShowDownloadConfirm] = useState(false);
  const [downloadType, setDownloadType] = useState("csv");

  const navigate = useNavigate();
  // const [isError, setError] = useState("");
  // const [isMessage, setMessage] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  //Restore Filter
  const [snapshotDate, setSnapshotDate] = useState([]);
  const [projects, setProjects] = useState([]);
  const [issueTypes, setIssueTypes] = useState([]);
  const [status, setStatus] = useState([]);
  const [formStateData, setFormStateData] = useState({});
  const [filterData, setFilterData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [progressTrack, setProgressTrack] = useState({
    whatToRestore: "visited",
    dataToRestoreFrom: "unvisited",
    filterData: "unvisited",
    previewData: "unvisited",
    restoreData: "unvisited",
  });
  //Restore Preview
  const [pageData, setPageData] = useState({
    //pagination: { page: "1", size: "50" },
    pagination: { nextToken: "", queryId: "" },
  });
  const [globalCheckState, setGlobalCheckState] = useState({
    allChecked: false,
    indeterminate: false,
    disabled: false,
  });
  const [restorePreviewPage, setRestorePreviewPage] = useState(false);
  const [restoreConfigPage, setRestoreConfigPage] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [queryForDownloadOrRestore, setqueryForDownloadOrRestore] =
    useState("");
  const [checkedIssues, setCheckedIssues] = useState([]);
  const [snapshotCount, setSnapshotCount] = useState(0);
  const [checkedItems, setCheckedItems] = useState([]);
  const [tempCheckedItems, setTempCheckedItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [nextTokenList, setNextTokenList] = useState([]);
  const [restoreType, setRestoreType] = useState(
    "restore_backed_up_issues_as_new_issues"
  );
  const [columnNames, setColumnNames] = useState([]);
  const { setMainMessage } = UseToast();
  useEffect(() => {
    const getData = async (token) => {
      setLoading(true);
      setMainMessage("");
      // setMessage("");
      const restoreTypeOption =
        restoreType === "restore_backed_up_issues_as_new_issues"
          ? "1"
          : restoreType === "restore_configuration"
          ? "2"
          : "";
      const queryParams = `type=${restoreTypeOption}`;
      await API.get(`api/snapshots?${queryParams}`, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          if (response.data.snapshots.length === 0) {
            // setMessage({ text: "No Snapshots Found", appearance: "info" });
            setMainMessage({ text: "No Snapshots Found", appearance: "info" });
          }
          setSnapshotDate(response.data.snapshots);
          setLoading(false);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ text: data.message, appearance: "error" });
          setLoading(false);
        });
    };

    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      getData(token);
    });
  }, [props.selected, props.appType, restoreType]);

  useEffect(() => {
    const perPageIssues = {};
    if (restoreType === "restore_backed_up_issues_as_new_issues")
      previewData.map((issue) => {
        if (Object.keys(tempCheckedItems).includes(issue.issueId)) {
          perPageIssues[issue.issueId] = tempCheckedItems[issue.issueId];
        }
        return perPageIssues;
      });
    else if (restoreType === "restore_configuration")
      previewData.map((ele) => {
        if (Object.keys(tempCheckedItems).includes(ele.id)) {
          perPageIssues[ele.id] = tempCheckedItems[ele.id];
        }
        return perPageIssues;
      });

    const areTrue =
      Object.values(perPageIssues).length > 0
        ? Object.values(perPageIssues).every(
            (issueSelected) =>
              issueSelected === true &&
              Object.values(perPageIssues).length === previewData.length
          )
        : false;
    const areFalse =
      Object.values(perPageIssues).length > 0
        ? Object.values(perPageIssues).every(
            (issueSelected) => issueSelected === false
          )
        : false;

    const checkedCount = Object.values(perPageIssues).filter(Boolean).length;
    if (areTrue) {
      setGlobalCheckState({
        indeterminate: false,
        allChecked: true,
        disabled: false,
      });
      if (checkedIssues.length > 49) {
        if (!areTrue) {
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: true,
            disabled: true,
          });
        } else {
          setGlobalCheckState({
            allChecked: true,
            indeterminate: false,
            disabled: false,
          });
        }
      } else {
        setGlobalCheckState({
          indeterminate: false,
          allChecked: true,
          disabled: false,
        });
      }
    } else if (areFalse) {
      setGlobalCheckState({
        indeterminate: false,
        allChecked: false,
        disabled: false,
      });
      if (checkedIssues.length > 49) {
        if (!globalCheckState.allChecked) {
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: false,
            disabled: true,
          });
        } else {
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: false,
            disabled: false,
          });
        }
      } else {
        setGlobalCheckState({
          ...globalCheckState,
          allChecked: false,
          disabled: false,
        });
      }
    } else if (
      !areFalse &&
      !areTrue &&
      checkedCount > 0 &&
      checkedCount < previewData.length
    ) {
      setGlobalCheckState({
        allChecked: true,
        indeterminate: true,
        disabled: false,
      });
      if (checkedIssues.length > 49) {
        if (!areTrue) {
          setGlobalCheckState({
            allChecked: true,
            indeterminate: true,
            disabled: false,
          });
        } else {
          setGlobalCheckState({
            ...globalCheckState,
            disabled: false,
          });
        }
      } else {
        setGlobalCheckState({
          allChecked: true,
          indeterminate: true,
          disabled: false,
        });
      }
    }
  }, [tempCheckedItems, checkedIssues]);

  useEffect(() => {
    let active = false;

    const getPreviewData = (token) => {
      // setError("");
      setMainMessage("");
      // setPreviewData([]);
      setTempCheckedItems({ ...tempCheckedItems });
      setCheckedItems([]);
      // const queryParams = `page=${pageData.pagination.page}&size=${
      //   pageData.pagination.size
      // }&snapshotId=${filterData.snapshotId}&projectId=${
      //   filterData.projectId
      // }&issueTypeId=${filterData.issueTypeId}${
      //   filterData.searchText ? `&searchText=${filterData.searchText}` : ""
      // }${
      //   filterData.issueStatusId.length !== 0
      //     ? `&issueStatusId=${JSON.stringify(filterData.issueStatusId)}`
      //     : ""
      // }`;
      if (restoreType === "restore_backed_up_issues_as_new_issues")
        getIssuesData(token, active);
      else if (restoreType === "restore_configuration")
        getConfigData(token, active);
    };
    if (filterData.length !== 0) {
      setLoading(true);
      //setSnapshotCount(0);
      setGlobalCheckState({
        indeterminate: false,
        allChecked: false,
        disabled: false,
      });
      // eslint-disable-next-line
      AP.context.getToken(function (token) {
        getPreviewData(token);
      });
    }

    return () => (active = true);
  }, [filterData, pageData]);

  //Reset the progress track when restoretype is changed.
  useEffect(() => {
    setProgressTrack({
      whatToRestore: "visited",
      dataToRestoreFrom: "unvisited",
      filterData: "unvisited",
      previewData: "unvisited",
      restoreData: "unvisited",
    });
  }, [restoreType]);

  let userNameList = [];
  let accountIdList1 = [];
  let avatarUrlList = [];
  const sendAllAccountId = (uniqueAccId, data) => {
    //Initialise data
    const initialdata = data.map((record) => {
      return {
        ...record,
        assigneeName: "-",
        assigneeAvatar: "",
        reporterName: "-",
        reporterAvatar: "",
      };
    });
    setPreviewData(initialdata);
    setLoading(false);
    var promise = new Promise(function (resolve, reject) {
      uniqueAccId.forEach((accountId, index) => {
        var promise2 = new Promise(function (resolve, reject) {
          //eslint-disable-next-line
          AP.request(`/rest/api/3/user?accountId=${accountId}`)
            .then((response) => {
              const responsedata = JSON.parse(response.body);
              resolve({
                displayName: responsedata.displayName,
                accountId: accountId,
                avatarUrl: Object.values(responsedata.avatarUrls)[1],
              });
            })
            .catch((e) =>
              reject({
                displayName: "Not found",
                accountId: accountId,
                avatarUrl: "",
              })
            );
        });
        promise2
          .then(({ displayName, accountId, avatarUrl }) => {
            userNameList.push(displayName);
            accountIdList1.push(accountId);
            avatarUrlList.push(avatarUrl);
            if (userNameList.length === uniqueAccId.length)
              resolve({
                nameList: userNameList,
                idList: accountIdList1,
                avatarList: avatarUrlList,
              });
          })
          .catch(({ displayName, accountId, avatarUrl }) => {
            userNameList.push(displayName);
            accountIdList1.push(accountId);
            avatarUrlList.push(avatarUrl);
            if (userNameList.length === uniqueAccId.length)
              reject({
                nameList: userNameList,
                idList: accountIdList1,
                avatarList: avatarUrlList,
              });
          });
      });
    });
    promise
      .then(({ nameList, idList, avatarList }) => {
        updateUserDetails(data, nameList, idList, avatarList);
      })
      .catch(({ nameList, idList, avatarList }) => {
        updateUserDetails(data, nameList, idList, avatarList);
      });
  };

  const updateUserDetails = (data, nameList, idList, avatarList) => {
    const newData = data.map((ele) => {
      let reporterIndex = idList.indexOf(ele.reporterId);
      let assigneeIndex = idList.indexOf(ele.assigneeId);
      if (reporterIndex !== -1 && assigneeIndex !== -1)
        return {
          ...ele,
          reporterName: nameList[reporterIndex],
          reporterAvatar: avatarList[reporterIndex],
          assigneeName: nameList[assigneeIndex],
          assigneeAvatar: avatarList[assigneeIndex],
        };
      if (reporterIndex === -1)
        return {
          ...ele,
          reporterName: null,
          reporterAvatar: null,
          assigneeName: nameList[assigneeIndex],
          assigneeAvatar: avatarList[assigneeIndex],
        };
      if (assigneeIndex === -1)
        return {
          ...ele,
          reporterName: nameList[reporterIndex],
          reporterAvatar: avatarList[reporterIndex],
          assigneeName: null,
          assigneeAvatar: null,
        };
      return { ...ele };
    });
    setPreviewData(newData);
    setLoading(false);
  };

  const getIssuesData = async (token, active) => {
    const queryParams = `projectId=${filterData.projectId}&snapshotId=${
      filterData.snapshotId
    }${filterData.issueTypeId ? `&issueTypeId=${filterData.issueTypeId}` : ""}${
      filterData.searchText ? `&searchText=${filterData.searchText}` : ""
    }${
      filterData.issueStatusId.length !== 0
        ? `&issueStatusId=${JSON.stringify(filterData.issueStatusId)}`
        : ""
    }${
      filterData.searchDescription
        ? `&searchDescription=${filterData.searchDescription}`
        : ""
    }`;
    if (
      pageData.pagination.queryId === "" &&
      pageData.pagination.nextToken === ""
    ) {
      setPreviewData([]);
      await API.get(`api/preview_issues?${queryParams}`, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setLoading(false);

          if (!active) {
            sendAllAccountId(
              response.data.uniqueAccountId,
              response.data.previewList
            );
            setSnapshotCount(response.data.totalCount);
            setPageData({
              pagination: {
                nextToken: response.data.nextPageToken,
                queryId: response.data.queryId,
              },
            });
            setNextTokenList(() => [response.data.nextPageToken]);
            setColumnNames(response.data.columnNames);
            setqueryForDownloadOrRestore(response.data.queryId);
            setPageNumber(1);
            setProgressTrack({
              ...progressTrack,
              previewData: "visited",
            });
            setTempCheckedItems({
              ...tempCheckedItems,
            });
            setLoading(false);
          }
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ text: data.message, appearance: "error" });
          setLoading(false);
          setRestorePreviewPage(false);
          setProgressTrack({
            whatToRestore: "visited",
            dataToRestoreFrom: "unvisited",
            filterData: "unvisited",
            previewData: "unvisited",
            restoreData: "unvisited",
          });
          setFormStateData({
            snapshotDate: null,
            project: null,
            issueType: null,
            status: null,
            searchText: "",
            searchDescription: "",
          });
        });
    }
  };

  const getConfigData = async (token, active) => {
    const queryParams = `snapshotId=${filterData.snapshotId}`;
    const endpoint =
      filterData.configType === "screens"
        ? "api/screens"
        : filterData.configType === "workflows"
        ? "api/workflows"
        : "";
    if (
      pageData.pagination.queryId === "" &&
      pageData.pagination.nextToken === ""
    ) {
      setPreviewData([]);
      await API.get(`${endpoint}?${queryParams}`, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setLoading(false);
          if (!active) {
            setqueryForDownloadOrRestore(response.data.queryId);
            setPreviewData(response.data.previewList);
            setSnapshotCount(response.data.totalCount);
            setNextTokenList(() => [response.data.nextPageToken]);
            setPageNumber(1);
            setColumnNames(response.data.columnNames);
            setPageData({
              pagination: {
                nextToken: response.data.nextPageToken,
                queryId: response.data.queryId,
              },
            });
            setProgressTrack({
              ...progressTrack,
              previewData: "visited",
            });
            setTempCheckedItems({
              ...tempCheckedItems,
            });
            setLoading(false);
          }
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ text: data.message, appearance: "error" });
          setLoading(false);
          setRestoreConfigPage(false);
          setProgressTrack({
            whatToRestore: "visited",
            dataToRestoreFrom: "unvisited",
            filterData: "unvisited",
            previewData: "unvisited",
            restoreData: "unvisited",
          });
          setFormStateData({
            snapshotDate: null,
            project: null,
            issueType: null,
            status: null,
            searchText: "",
            searchDescription: "",
            configType: "",
          });
        });
    }
  };

  const handleSnapshotDate = (e) => {
    setLoading(true);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      getProjects(token, e);
    });
  };

  const getProjects = async (token, e) => {
    setProjects([]);
    setIssueTypes([]);
    setStatus([]);
    // setError("");
    setMainMessage("");

    await API.get(`api/projects?snapshotId=${e.snapshotId}`, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        setProjects(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        // setError(data.message);
        setMainMessage({ text: data.message, appearance: "error" });
        setLoading(false);
      });
  };

  const handleProjectData = (e) => {
    setLoading(true);
    setProgressTrack({
      ...progressTrack,
      dataToRestoreFrom: "visited",
    });
    setIssueTypes(e.issueType);
    setStatus(e.issueStatus);
    setLoading(false);
  };

  const handleModal = () => {
    setModalIsOpen(true);
  };

  const handleFormReset = () => {
    setFormStateData({
      snapshotDate: null,
      project: null,
      issueType: null,
      status: null,
      searchText: "",
      searchDescription: "",
    });
    setProgressTrack({
      ...progressTrack,
      dataToRestoreFrom: "unvisited",
      filterData: "unvisited",
      previewData: "unvisited",
    });
    setModalIsOpen(false);
  };

  const handleExportData = (type) => {
    const filterData = {
      project: formStateData.project,
      snapshotDate: formStateData.snapshotDate,
      fileType: type,
    };

    // setMessage("");
    // setError("");
    setMainMessage("");

    setLoading(true);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      API.post(`/api/export_data`, filterData, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          // setError("");
          setLoading(false);
          // setMessage("");
          setMainMessage("");

          if (
            response.status === 200 &&
            response.data.exportTriggered === true
          ) {
            // props.setSelected(1);
            navigate("/restore/jobs");

            // setMessage({
            //   text: "Export Job triggered successfully!",
            //   appearance: "success",
            // });
            setMainMessage({
              text: "Export job(s) initiated successfully!",
              appearance: "success",
            });
          } else if (
            response.status === 200 &&
            response.data.exportTriggered === false
          ) {
            // props.setSelected(1);
            navigate("/restore/jobs");
            // setMessage({
            //   text: "Export issues job is already running.",
            //   appearance: "info",
            // });
            setMainMessage({
              text: "Export issues job is already running.",
              appearance: "info",
            });
          }
        })
        .catch(function (error) {
          // setError(error.message);
          setMainMessage({ text: error.message, appearance: "error" });
          setLoading(false);
        });
    });
  };

  const handleMapField = (dt) => {
    setRestorePreviewPage(true);

    if (!checkFilterData(dt, filterData)) {
      setLoading(true);
      setCheckedItems([]);
      setPageData({
        pagination: {
          nextToken: "",
          queryId: "",
        },
      });
      setTempCheckedItems([]);
      setCheckedIssues([]);
      setFilterData(dt);
      setPreviewData([]);
      setProgressTrack({
        ...progressTrack,
        previewData: "unvisited",
        filterData: "visited",
      });
    } else {
      setProgressTrack({
        ...progressTrack,
        previewData: "visited",
        filterData: "visited",
      });
    }
  };

  const handleProgressTrack = (selectionType) => {
    if (selectionType === "snapshotSelected")
      setProgressTrack({
        ...progressTrack,
        dataToRestoreFrom: "visited",
      });
  };

  const handleConfigField = (dt) => {
    setRestoreConfigPage(true);
    if (!checkFilterData(dt, filterData)) {
      setLoading(true);
      setCheckedItems([]);
      setPageData({
        pagination: {
          nextToken: "",
          queryId: "",
        },
      });
      setTempCheckedItems([]);
      setCheckedIssues([]);
      setFilterData(dt);
      setPreviewData([]);
      setProgressTrack({
        ...progressTrack,
        previewData: "unvisited",
        filterData: "visited",
      });
    } else {
      setProgressTrack({
        ...progressTrack,
        previewData: "visited",
        filterData: "visited",
      });
    }
  };

  const handleRestoreType = (type) => {
    setRestoreType(type);
  };

  const handlePreviewBack = () => {
    setLoading(false);
    setRestorePreviewPage(false);
    setProgressTrack({
      ...progressTrack,
      previewData: "unvisited",
      filterData: "unvisited",
    });
  };

  const handlePreviewConfigBack = () => {
    setLoading(false);
    setRestoreConfigPage(false);
    setProgressTrack({
      ...progressTrack,
      previewData: "unvisited",
      filterData: "unvisited",
    });
  };

  const handleCheckboxCheckAll = (event) => {
    let issuesTobeChecked = {};

    previewData.map((val) => {
      if (event.target.checked) {
        if (checkedIssues.length > 49) {
          return true;
        }
        issuesTobeChecked[val.issueId] = true;
        setUniqueIssues(checkedIssues, val);
      } else {
        issuesTobeChecked[val.issueId] = false;
        issuesToRemove(val.issueId, checkedIssues);
      }
      return issuesTobeChecked;
    });
    setCheckedItems({
      ...checkedItems,
      ...issuesTobeChecked,
    });

    setTempCheckedItems({
      ...tempCheckedItems,
      ...issuesTobeChecked,
    });
  };

  //handle checkbox all select for config restore
  const handleCheckboxCheckAllConfig = (event) => {
    let issuesTobeChecked = {};

    previewData.map((val) => {
      if (event.target.checked) {
        if (checkedIssues.length > 49) {
          return true;
        }
        issuesTobeChecked[val.id] = true;
        setUniqueIssues(checkedIssues, val, true);
      } else {
        issuesTobeChecked[val.id] = false;
        issuesToRemove(val.id, checkedIssues, true);
      }
      return issuesTobeChecked;
    });
    setCheckedItems({
      ...checkedItems,
      ...issuesTobeChecked,
    });

    setTempCheckedItems({
      ...tempCheckedItems,
      ...issuesTobeChecked,
    });
  };

  const handleCheckboxCheck = (event, issueId) => {
    if (event.target.checked) {
      if (checkedIssues.length > 49) {
        return;
      }
    }
    if (checkedIssues.length > 49) {
      if (!event.target.checked) {
        setGlobalCheckState({
          ...globalCheckState,
          indeterminate: true,
          disabled: true,
        });
      } else {
        setGlobalCheckState({
          ...globalCheckState,
          disabled: false,
        });
      }
    } else {
      setGlobalCheckState({
        allChecked: true,
        indeterminate: true,
        disabled: false,
      });
    }
    const newCheckedItems = {
      ...tempCheckedItems,
      [issueId.issueId]: !tempCheckedItems[issueId.issueId],
    };

    setCheckedItems({
      ...checkedItems,
      [issueId.issueId]: !tempCheckedItems[issueId.issueId],
    });
    setTempCheckedItems({
      ...newCheckedItems,
    });
    if (event.target.checked) {
      setCheckedIssues([...checkedIssues, issueId]);
    } else {
      issuesToRemove(issueId.issueId, checkedIssues);
      // checkedIssues.splice(checkedIssues.indexOf(issueId), 1);
    }
  };

  //Handle check box on restore config
  const handleCheckboxCheckConfig = (event, id) => {
    if (event.target.checked) {
      if (checkedIssues.length > 49) {
        return;
      }
    }
    if (checkedIssues.length > 49) {
      if (!event.target.checked) {
        setGlobalCheckState({
          ...globalCheckState,
          indeterminate: true,
          disabled: true,
        });
      } else {
        setGlobalCheckState({
          ...globalCheckState,
          disabled: false,
        });
      }
    } else {
      setGlobalCheckState({
        allChecked: true,
        indeterminate: true,
        disabled: false,
      });
    }
    const newCheckedItems = {
      ...tempCheckedItems,
      [id.id]: !tempCheckedItems[id.id],
    };

    setCheckedItems({
      ...checkedItems,
      [id.id]: !tempCheckedItems[id.id],
    });
    setTempCheckedItems({
      ...newCheckedItems,
    });
    if (event.target.checked) {
      setCheckedIssues([...checkedIssues, id]);
    } else {
      issuesToRemove(id.id, checkedIssues);
    }
  };

  const handleRestoreData = () => {
    const data = {
      restore_issues: {
        previewList: checkedIssues,
        totalCount: checkedIssues.length,
        queryId: pageData.pagination.queryId,
      },
      filters_raw: filterData,
    };
    setLoading(true);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      postIssues(token, data, filterData);
    });
  };
  const postIssues = async (token, data) => {
    // setError("");
    setMainMessage("");

    //const queryParams = `snapshot_id=${filterData.snapshotId}&project_id=${filterData.projectId}&issueTypes=${filterData.issueTypeId}&issueStatus=${filterData.issueStatusId}`;
    const queryParams = `snapshot_id=${filterData.snapshotId}&project_id=${filterData.projectId}`;
    await API.post(`api/issue_restore?${queryParams}`, data, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        setProgressTrack({
          ...progressTrack,
          restoreData: "current",
        });
        setCheckedIssues([]);
        setCheckedItems([]);
        // setError("");
        setMainMessage("");

        // setMessage("");
        setMainMessage("");
        setTempCheckedItems([]);
        setFormStateData({
          snapshotDate: null,
          project: null,
          issueType: null,
          status: null,
          searchText: "",
          searchDescription: "",
        });
        setPreviewData([]);
        setFilterData([]);
        setSnapshotCount(0);
        setProgressTrack({
          whatToRestore: "visited",
          dataToRestoreFrom: "unvisited",
          filterData: "unvisited",
          previewData: "unvisited",
          restoreData: "unvisited",
        });
        setRestorePreviewPage(false);
        // props.setSelected(1);
        navigate("/restore/jobs");
        // setMessage({
        //   text: "Issue restore job triggered successfully",
        //   appearance: "success",
        // });
        setMainMessage({
          text: "Issue restore job triggered successfully",
          appearance: "success",
        });
        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        // setError(data.message);
        setMainMessage({
          text: data.message,
          appearance: "error",
        });
        setLoading(false);
      });
  };

  const handleRestoreConfig = () => {
    const data = {
      queryId: pageData.pagination.queryId,
      snapshotId: filterData.snapshotId,
      previewList: checkedIssues,
      filters_raw: filterData,
    };
    setLoading(true);
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      postConfig(token, data);
    });
  };

  const postConfig = async (token, data) => {
    // setError("");
    setMainMessage("");

    const endpoint =
      filterData.configType === "screens"
        ? "api/restore_screens"
        : filterData.configType === "workflows"
        ? "api/restore_workflows"
        : "";
    await API.post(endpoint, data, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        setProgressTrack({
          ...progressTrack,
          restoreData: "current",
        });
        setCheckedIssues([]);
        setCheckedItems([]);
        // setError("");
        setMainMessage("");

        // setMessage("");
        setMainMessage("");
        setTempCheckedItems([]);
        setFormStateData({
          snapshotDate: null,
          project: null,
          issueType: null,
          status: null,
          searchText: "",
          searchDescription: "",
        });
        setPreviewData([]);
        setFilterData([]);
        setSnapshotCount(0);
        setProgressTrack({
          whatToRestore: "visited",
          dataToRestoreFrom: "unvisited",
          filterData: "unvisited",
          previewData: "unvisited",
          restoreData: "unvisited",
        });
        setRestoreConfigPage(false);
        // props.setSelected(1);
        navigate("/restore/jobs");
        // setMessage({
        //   text: "Restore job triggered successfully",
        //   appearance: "success",
        // });
        setMainMessage({
          text: "Restore job(s) initiated successfully",
          appearance: "success",
        });
        setLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        // setError(data.message);
        setMainMessage({ text: data.message, appearance: "error" });
        setLoading(false);
      });
  };

  const handleDownloadData = (type) => {
    setLoading(true);
    let url,
      data,
      fileNameSubPart = "";
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      downloadFile(token, type);
    });
    const downloadFile = async (token, type) => {
      // setError("");
      setMainMessage("");

      if (restoreType === "restore_backed_up_issues_as_new_issues") {
        url = "api/download_preview_list";
        data = {
          fileFormat: type,
          operation: "download:preview_list",
          queryId: pageData.pagination.queryId,
          restore_issues: {
            previewList: checkedIssues,
            totalCount: checkedIssues.length,
          },
          queryId: queryForDownloadOrRestore,
          //
        };
        fileNameSubPart = formStateData.project.projectName;
      } else if (restoreType === "restore_configuration") {
        url = "api/download/config";
        data = {
          fileFormat: type,
          configuration: filterData.configType,
          previewList: checkedIssues,
          queryId: queryForDownloadOrRestore,
        };
        fileNameSubPart = camelToTitle(filterData.configType);
      }

      await API.post(url, data, {
        responseType: type === "csv" ? "arraybuffer" : "json",
        headers: {
          Authorization: `JWT ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then(function (response) {
          setCheckedIssues([]);
          const newCheckedItems = Object.fromEntries(
            Object.keys(checkedItems).map((key) => [key, false])
          );
          const newTempCheckedItems = Object.fromEntries(
            Object.keys(tempCheckedItems).map((key) => [key, false])
          );
          setGlobalCheckState({
            ...globalCheckState,
            allChecked: false,
          });
          setCheckedItems(newCheckedItems);
          setTempCheckedItems(newTempCheckedItems);
          // let jsonString;
          const fileName =
            `Revyz_${fileNameSubPart}_` +
            moment().utc().format("MM-DD-YYYY") +
            "-" +
            moment().utc().get("hour") +
            "-" +
            moment().utc().get("minute") +
            "-" +
            moment().utc().get("second");
          if (type === "json") {
            const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
              JSON.stringify(response.data, null, 4)
            )}`;
            const link = document.createElement("a");
            link.href = jsonString;
            link.download = fileName + ".json";
            link.click();
            link.remove();
          } else if (type === "csv") {
            const jsonString = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const link = document.createElement("a");
            link.href = jsonString;
            link.download = fileName + ".csv";
            link.click();
            link.remove();
          }
          setLoading(false);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ text: data.message, appearance: "error" });
          setLoading(false);
        });
    };
  };

  const getPrevData = () => {
    setLoading(true);
    const currentPageNumber = pageNumber;
    setPageNumber((prevState) => prevState - 1);
    const prevPageToken =
      currentPageNumber === 2 ? null : nextTokenList[currentPageNumber - 3];
    const type =
      restoreType === "restore_backed_up_issues_as_new_issues"
        ? "1"
        : filterData.configType === "screens"
        ? "2"
        : filterData.configType === "workflows"
        ? "3"
        : "";
    const data = {
      nextPageToken: prevPageToken,
      queryId: pageData.pagination.queryId,
      columnNames: columnNames,
      type: type,
    };
    const getPrevPageData = async (token) => {
      await API.post(`api/paginate_results?`, data, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          if (data.type === "1") {
            sendAllAccountId(
              response.data.uniqueAccountId,
              response.data.previewList
            );
          } else setPreviewData(response.data.previewList);
          // setSnapshotCount(response.data.totalCount);
          // setNextTokenList((val) => [...val, response.data.nextPageToken]);
          setPageData({
            pagination: {
              nextToken: response.data.nextPageToken,
              queryId: response.data.queryId,
            },
          });
          setProgressTrack({
            ...progressTrack,
            previewData: "visited",
          });
          setTempCheckedItems({
            ...tempCheckedItems,
          });
          setLoading(false);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ text: data.message, appearance: "error" });
          setLoading(false);
          setRestorePreviewPage(false);
          setProgressTrack({
            whatToRestore: "visited",
            dataToRestoreFrom: "unvisited",
            filterData: "unvisited",
            previewData: "unvisited",
            restoreData: "unvisited",
          });
          setFormStateData({
            snapshotDate: null,
            project: null,
            issueType: null,
            status: null,
            searchText: "",
            searchDescription: "",
          });
        });
    };
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      getPrevPageData(token);
    });
  };

  const getNextData = () => {
    setLoading(true);
    const type =
      restoreType === "restore_backed_up_issues_as_new_issues"
        ? "1"
        : filterData.configType === "screens"
        ? "2"
        : filterData.configType === "workflows"
        ? "3"
        : "";
    const data = {
      nextPageToken: pageData.pagination.nextToken,
      queryId: pageData.pagination.queryId,
      columnNames: columnNames,
      type: type,
    };
    const getNextPageData = async (token) => {
      await API.post(`api/paginate_results?`, data, {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setPageNumber((prevState) => prevState + 1);
          if (data.type === "1") {
            sendAllAccountId(
              response.data.uniqueAccountId,
              response.data.previewList
            );
          } else setPreviewData(response.data.previewList);
          setSnapshotCount(response.data.totalCount);
          setNextTokenList((val) => [...val, response.data.nextPageToken]);
          setPageData({
            pagination: {
              nextToken: response.data.nextPageToken,
              queryId: response.data.queryId,
            },
          });
          setProgressTrack({
            ...progressTrack,
            previewData: "visited",
          });
          setTempCheckedItems({
            ...tempCheckedItems,
          });
          setLoading(false);
        })
        .catch(function (error) {
          const data = errorHandler(error);
          // setError(data.message);
          setMainMessage({ text: data.message, appearance: "error" });
          setLoading(false);
          setRestorePreviewPage(false);
          setProgressTrack({
            whatToRestore: "visited",
            dataToRestoreFrom: "unvisited",
            filterData: "unvisited",
            previewData: "unvisited",
            restoreData: "unvisited",
          });
          setFormStateData({
            snapshotDate: null,
            project: null,
            issueType: null,
            status: null,
            searchText: "",
            searchDescription: "",
          });
        });
    };
    // eslint-disable-next-line
    AP.context.getToken(function (token) {
      getNextPageData(token);
    });
  };

  if (restorePreviewPage) {
    return (
      <>
        <ModalTransition>
          {showConfirmation && (
            <Modal onClose={() => setShowConfirmation(false)}>
              <ModalHeader>
                <ModalTitle>Restore Issue(s)</ModalTitle>
              </ModalHeader>
              <ModalBody>
                Restoring issue(s) will create new issue(s) without updating
                original ones.
                <br />
                <br />
                Are you sure you want to restore the selected issue(s) ?
                {isLoading && <Spinner size="small" />}
              </ModalBody>
              <ModalFooter>
                <Button
                  appearance="subtle"
                  onClick={() => setShowConfirmation(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    handleRestoreData();
                    setShowConfirmation(false);
                  }}
                  appearance="primary"
                  autoFocus
                >
                  Restore
                </Button>
              </ModalFooter>
            </Modal>
          )}

          {showDownloadConfirm && (
            <Modal onClose={() => setShowDownloadConfirm(false)}>
              <ModalHeader>
                <ModalTitle> Download issue(s)</ModalTitle>
              </ModalHeader>
              <ModalBody>
                This action will download a {downloadType} file containing
                selected issue(s).
              </ModalBody>
              <ModalFooter>
                <Button
                  appearance="subtle"
                  onClick={() => setShowDownloadConfirm(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    handleDownloadData(downloadType);
                    setShowDownloadConfirm(false);
                  }}
                  appearance="primary"
                  autoFocus
                >
                  Download
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </ModalTransition>
        {/* {isMessage ? (
          <div className={styles.error}>
            <FlagError setFlag={[1]} message={isMessage} />
          </div>
        ) : (
          ""
        )} */}
        {/* {isError ? (
          <div className={styles.error}>
            <FlagError setFlag={[1]} message={isError} />
          </div>
        ) : (
          ""
        )} */}
        <RestorePreview
          previewData={previewData}
          progressTrack={progressTrack}
          projects={projects}
          issueTypes={issueTypes}
          status={status}
          pageNumber={pageNumber}
          nextTokenList={nextTokenList}
          tempCheckedItems={tempCheckedItems}
          snapshotCount={snapshotCount}
          isLoading={isLoading}
          formStateData={formStateData}
          pageData={pageData}
          checkedIssues={checkedIssues}
          filterData={filterData}
          globalCheckState={globalCheckState}
          handlePreviewBack={handlePreviewBack}
          handleRestoreData={handleRestoreData}
          handleCheckboxCheck={handleCheckboxCheck}
          handleCheckboxCheckAll={handleCheckboxCheckAll}
          handleMapField={handleMapField}
          setFormStateData={setFormStateData}
          handleProjectData={handleProjectData}
          handleDownloadData={handleDownloadData}
          getPrevData={getPrevData}
          getNextData={getNextData}
          setShowConfirmation={setShowConfirmation}
          setShowDownloadConfirm={setShowDownloadConfirm}
          setDownloadType={setDownloadType}
        />
      </>
    );
  }
  if (restoreConfigPage) {
    return (
      <>
        <ModalTransition>
          {showConfirmation && (
            <Modal onClose={() => setShowConfirmation(false)}>
              <ModalHeader>
                <ModalTitle>
                  Restore{" "}
                  {filterData.configType === "screens"
                    ? "screen(s) "
                    : "workflow(s) "}
                  {isLoading && <Spinner size="small" />}
                </ModalTitle>
              </ModalHeader>
              <ModalBody>
                Restoring{" "}
                {filterData.configType === "screens"
                  ? "screen(s)"
                  : "workflow(s)"}{" "}
                will create new{" "}
                {filterData.configType === "screens"
                  ? "screen(s)"
                  : "workflow(s)"}{" "}
                without updating original ones.
                <br />
                <br />
                Are you sure you want to restore the selected{" "}
                {filterData.configType === "screens"
                  ? "screen(s)"
                  : "workflow(s)"}
                ?
              </ModalBody>
              <ModalFooter>
                <Button
                  appearance="subtle"
                  onClick={() => setShowConfirmation(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    handleRestoreConfig();
                    setShowConfirmation(false);
                  }}
                  appearance="primary"
                  autoFocus
                >
                  Restore
                </Button>
              </ModalFooter>
            </Modal>
          )}

          {showDownloadConfirm && (
            <Modal onClose={() => setShowDownloadConfirm(false)}>
              <ModalHeader>
                <ModalTitle>
                  Download{" "}
                  {filterData.configType === "screens"
                    ? "screen(s) "
                    : "workflow(s) "}
                </ModalTitle>
              </ModalHeader>
              <ModalBody>
                This action will download a {downloadType} file containing
                selected{" "}
                {filterData.configType === "screens"
                  ? "screen(s) "
                  : "workflow(s) "}
                .
              </ModalBody>
              <ModalFooter>
                <Button
                  appearance="subtle"
                  onClick={() => setShowDownloadConfirm(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    handleDownloadData(downloadType);
                    setShowDownloadConfirm(false);
                  }}
                  appearance="primary"
                  autoFocus
                >
                  Download
                </Button>
              </ModalFooter>
            </Modal>
          )}
        </ModalTransition>
        {/* {isMessage ? (
          <div className={styles.error}>
            <FlagError setFlag={[1]} message={isMessage} />
          </div>
        ) : (
          ""
        )} */}
        {/* {isError ? (
          <div className={styles.error}>
            <FlagError setFlag={[1]} message={isError} />
          </div>
        ) : (
          ""
        )} */}
        <RestorePreviewConfig
          previewData={previewData}
          progressTrack={progressTrack}
          pageNumber={pageNumber}
          nextTokenList={nextTokenList}
          tempCheckedItems={tempCheckedItems}
          snapshotCount={snapshotCount}
          isLoading={isLoading}
          formStateData={formStateData}
          pageData={pageData}
          checkedIssues={checkedIssues}
          filterData={filterData}
          globalCheckState={globalCheckState}
          handlePreviewConfigBack={handlePreviewConfigBack}
          handleRestoreConfig={handleRestoreConfig}
          handleCheckboxCheckConfig={handleCheckboxCheckConfig}
          handleCheckboxCheckAllConfig={handleCheckboxCheckAllConfig}
          setFormStateData={setFormStateData}
          handleProjectData={handleProjectData}
          handleDownloadData={handleDownloadData}
          getPrevData={getPrevData}
          getNextData={getNextData}
          setShowConfirmation={setShowConfirmation}
          setShowDownloadConfirm={setShowDownloadConfirm}
          setDownloadType={setDownloadType}
        />
      </>
    );
  }
  return (
    <div className={styles.container}>
      {modalIsOpen ? (
        <ModalPrompt
          modalTitle="Reset Filters?"
          modalBody="Resetting this page will clear all the selected filters."
          isOpen={modalIsOpen}
          setOpen={setModalIsOpen}
          primaryButtonName="Reset"
          primaryButtonAction={handleFormReset}
        />
      ) : (
        ""
      )}
      {isLoading ? (
        <div className={styles.spinner}>
          <Spinner size="large" />
        </div>
      ) : (
        ""
      )}
      {/* {isMessage ? (
        <div className={styles.error}>
          <FlagError setFlag={[1]} message={isMessage} />
        </div>
      ) : (
        ""
      )} */}
      {/* {isError ? (
        <div className={styles.error}>
          <FlagError setFlag={[1]} message={isError} />
        </div>
      ) : (
        ""
      )} */}
      <RestoreFilter
        snapshotDates={snapshotDate}
        issueTypes={issueTypes}
        status={status}
        isLoading={isLoading}
        formStateData={formStateData}
        projects={projects}
        progressTrack={progressTrack}
        restoreType={restoreType}
        handleRestoreType={handleRestoreType}
        handleSnapshotDate={handleSnapshotDate}
        handleProjectData={handleProjectData}
        setFormStateData={setFormStateData}
        handleMapField={handleMapField}
        handleFormReset={handleModal}
        handleExportData={handleExportData}
        handleProgressTrack={handleProgressTrack}
        handleConfigField={handleConfigField}
      />
    </div>
  );
};

export default Restore;
